import React from "react";
import LocalizedLink from "../containers/LocalizedLink";

import SupportQuestionAnswer from "./SupportQuestionAnswer";

  const SupportTechnical = props => (
      <React.Fragment>
        <section className="grid grid--3" style={{ marginTop: "55px" }}>
          <LocalizedLink className="grid__item" to="/support/business">
            <div className="grid__item-title">{props.t("support:titleBusinessQuestion")}</div>
          </LocalizedLink>
          <LocalizedLink className="grid__item" to="/support/technical">
            <div className="grid__item-title font-bold">{props.t("support:titleTechnicalQuestion")}</div>
          </LocalizedLink>
          <LocalizedLink className="grid__item" to="/support/acoustic">
            <div className="grid__item-title">{props.t("support:titleAcousticQuestion")}</div>
          </LocalizedLink>
        </section>

    <div className="grid grid--3 flex-wrap">
      {/*    <div className="grid__item support__item support__item--gray">*/}

      <SupportQuestionAnswer
        question={props.t("question1")}
        boldWords={props.t("boldWords1")}
        answer={props.t("answer1")}
        classQuestion="question"
      />
      <SupportQuestionAnswer
      question={props.t("question2")}
      boldWords={props.t("boldWords2")}
      answer={props.t("answer2")}
        classQuestion="question"
      />
      <SupportQuestionAnswer
      question={props.t("question3")}
      boldWords={props.t("boldWords3")}
      answer={props.t("answer3")}
        classQuestion="question"
      />
      <SupportQuestionAnswer
        question={props.t("question4")}
        boldWords={props.t("boldWords4")}
        answer={props.t("answer4")}
        classQuestion="question"
      />
      <SupportQuestionAnswer
      question={props.t("question5")}
      boldWords={props.t("boldWords5")}
      answer={props.t("answer5")}
        classQuestion="question"
      />
      <SupportQuestionAnswer
      question={props.t("question6")}
      boldWords={props.t("boldWords6")}
      answer={props.t("answer6")}
        classQuestion="question"
      />
      <SupportQuestionAnswer
        question={props.t("question7")}
        boldWords={props.t("boldWords7")}
        boldWords2={props.t("boldWords7_1")}
        answer={props.t("answer7")}
        classQuestion="question"
      />
      <SupportQuestionAnswer
      question={props.t("question8")}
      boldWords={props.t("boldWords8")}
      answer={props.t("answer8")}
        classQuestion="question"
      />
      <SupportQuestionAnswer
      question={props.t("question9")}
      boldWords={props.t("boldWords9")}
      answer={props.t("answer9")}
        classQuestion="question"
      />
    </div>
  </React.Fragment>
);

export default SupportTechnical;



// WEBPACK FOOTER //
// ./src/components/SupportTechnical.js